// removed by extract-text-webpack-plugin
module.exports = {"base":"base___dwj_P","primary":"primary___2JINz","brand":"brand___bzVZ8","terciary":"terciary___2IcJ5","correct":"correct___4DWu7","wrong":"wrong___1jBVY","accent":"accent___NgGhH","negative":"negative___25j1U","black":"black___2sUe2","standard":"standard___2P1Io","custom":"custom___3GyY2","smaller":"smaller___1hCqU","small":"small___2Ads6","medium":"medium___NIGQo","big":"big___34PCF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/index.scss
// module id = 84
// module chunks = 0